import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import moment from 'moment';
import { get } from '../../../../../Model/Network/Config/Axios';
import { KeyValue } from '../../../../Common/Components/KeyValue';
import Container from '../../../../Common/fAnalytics/Container';
import { PieGraph } from '../../../../Common/fAnalytics';
import { DownloadCsv } from '../../../../../Utils/Downloader';
import { Modal } from '../../../../Common/fModal/Modal';


const AllocationView = forwardRef(({ type, reference, logs, title, poData, onAdd, onUpdate, onRemove }, ref) => {


    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});
    const [showChart, setShowChart] = useState(false);
    const [toggleData] = useState('ratio');
    const [viewLogs, setViewLogs] = useState(false);

    const log = (item) => {
        return (
            <div>
                <KeyValue title='Log' value={(item && item.log) ? item.log : ""} />
                <KeyValue title='Owner Name' value={(item && item.owner && item.owner.ownerName) ? item.owner.ownerName : ""} />
                <KeyValue title='Owner ID' value={(item && item.ownerId) ? item.ownerId : ""} />
                <KeyValue title='Owner Type' value={(item && item.ownerType) ? item.ownerType : ""} />
                <KeyValue title='Remarks' value={(item && item.remarks) ? item.remarks : ""} />
                <KeyValue title='Time' value={(item && item.time) ? moment(item.time).format("DD-MM-YYYY") : ""} />
            </div>
        )
    }


    useImperativeHandle(ref, () => ({
        INIT: () => INIT()
    }))


    let INIT = () => {
        setLoading(true);
        setTimeout(() => {
            get(`vendor/costAllocation/getAllocations?referenceType=${type}&referenceId=${reference}`, (e, r) => {
                if (r) {
                    setData(r);
                    setLoading(false);
                } else {
                    setData({})
                    setLoading(false);
                }
            })
        }, 1000);
    }

    useEffect(() => {
        get(`vendor/costAllocation/getAllocations?referenceType=${type}&referenceId=${reference}`, (e, r) => {
            if (r) {
                const allocations = r.data.allocations;
                // Check if allocations is array and has items with amount 0
                if (Array.isArray(allocations) && allocations.length > 0 && type === 'purchase-order' && poData && poData.procured) {
                    const hasZeroAmount = allocations.some(allocation => allocation.amount === 0);
                    
                    if (hasZeroAmount) {
                        // Calculate sum of base amounts from procured items
                        const totalBaseAmount = poData.procured.reduce((sum, item) => {
                            return sum + (item.amount || 0);
                        }, 0);
                        
                        // Update allocations with calculated amounts based on ratio
                        const updatedAllocations = allocations.map(allocation => {
                            if (allocation.amount === 0 && allocation.ratio > 0) {
                                const calculatedAmount = (allocation.ratio / 100) * totalBaseAmount;
                                return {
                                    ...allocation,
                                    amount: calculatedAmount
                                };
                            }
                            return allocation;
                        });
                        
                        // Update the response data with calculated amounts
                        r.data.allocations = updatedAllocations;
                        r.data.totalAllocatedAmount = totalBaseAmount;
                    }
                }
                
                setData(r);
                setLoading(false);
            } else {
                setData({})
                setLoading(false);
            }
        })
    }, [reference, type, poData])

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '150px',
                fontSize: '16px',
                color: '#666'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '10px'
                }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #f3f3f3',
                        borderTop: '4px solid #767DFF',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                    }}></div>
                    <div>Loading allocation data...</div>
                </div>
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        )
    }

    let { allocations, baseType, totalAllocatedAmount } = (data && data.data) ? data.data : { allocations: [], baseType: '', totalAllocatedAmount: 0 };
    const pieItems = allocations && allocations.length > 0 ? allocations.map(e => e.location) : [];
    const pieData = allocations && allocations.length > 0 ? allocations.map(e => e[toggleData]) : [];

    if ((!allocations || (allocations.length === 0)) && !loading) {
        return (
            <div>
                <div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>
                    No Cost Allocation Found
                </div>
                {poData && poData.status === 'DRAFT' &&
                    <div style={{
                        background: '#fff',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        borderTop: '1px solid var(--border-color)', height: 55, padding: '10px'
                    }}>
                        <div onClick={() => {
                            onAdd()
                        }} className='btn btn-portlet' style={{ background: "#E4EFE7", }}>
                            Add Cost Allocation
                        </div>
                    </div>
                }
            </div>
        )
    }
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <div style={{ fontSize: '14px', fontWeight: 'bold', margin: '30px 0px 10px 0px' }}>{title ? title : "Cost Allocation"}</div>
                {
                    logs && logs.length > 0 ? <div onClick={() => { setViewLogs(true) }} style={{ fontWeight: 'bold', cursor: 'pointer', marginLeft: '15rem' }}>Show Logs</div> : null
                }
                <div className="flex flex-v-center" style={{
                    backgroundColor: '#767DFF',
                    height: 22,
                    width: 100,
                    borderRadius: 32,
                    cursor: 'pointer',
                    padding: '0px 3px',
                }}>
                    <div className="flex flex-v-center" style={{ flex: 1, height: '100%' }}>
                        <p onClick={() => setShowChart(false)} className="flex flex-v-center flex-h-center" style={{
                            flex: 1,
                            textAlign: 'center',
                            fontSize: 11,
                            height: '78%',
                            ...!showChart ? {
                                backgroundColor: '#fff',
                                borderRadius: 32,
                                color: '#767DFF'
                            } : {
                                color: '#fff'
                            }
                        }}>
                            Table
                        </p>
                        <p onClick={() => setShowChart(true)} className="flex flex-v-center flex-h-center" style={{
                            flex: 1,
                            textAlign: 'center',
                            fontSize: 11,
                            height: '78%',
                            ...showChart ? {
                                backgroundColor: '#fff',
                                borderRadius: 32,
                                color: 'var(--active-background)'
                            } : {
                                color: '#fff'
                            }
                        }}>
                            Chart
                        </p>
                    </div>
                </div>
            </div>
            <KeyValue title='Allocation Type' value={baseType} />
            <KeyValue title='Total Allocation Amount' value={totalAllocatedAmount} />
            {!showChart &&
                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                    <p
                        onClick={() => {
                            let base = [['location', 'Ratio', 'Amount']];
                            allocations.forEach(item => {
                                let temp = [item.location, item.ratio.toFixed(2), item.amount.toFixed(3)]
                                base.push(temp);
                            });
                            DownloadCsv("costAllocation.csv", base);
                        }}
                        className="btn btn-portlet"
                        style={{
                            width: '98px',
                            fontSize: '9px',
                            padding: '4px 0px',
                            margin: '0 10px 10px 0',
                        }}
                    >
                        {"Download Csv"}
                    </p>
                </div>
            }
            {!showChart && <div>
                <div style={{ background: '#F9F9FA', height: 30, display: 'flex', alignItems: 'center' }}>
                    {
                        [
                            { name: 'location', style: { flex: 3, fontWeight: 'bold' } },
                            { name: 'Ratio', style: { flex: 1, fontWeight: 'bold' } },
                            { name: 'Amount', style: { flex: 1, fontWeight: 'bold' } },

                        ].map((item, index) => {
                            return (
                                <div key={index} style={{ display: 'flex', border: '1px solid var(--border-color)', borderTopLeftRadius: 2, borderTopRightRadius: 2, height: 30, paddingLeft: 5, alignItems: 'center', flex: 1, ...item.style }}>
                                    {item.name}
                                </div>
                            )
                        })
                    }
                </div>

                {
                    allocations.map((item, index) => {
                        return (
                            <div key={index} style={{ display: 'flex', flex: 1, minHeight: 35, border: '1px solid var(--border-color)' }}>
                                <div style={{ minHeight: 35, flex: 3, padding: 5, display: 'flex', alignItems: 'center', borderRight: '1px solid var(--border-color)' }}>
                                    {item.location} <br></br>
                                    {item.budgetId ? <>{item.budgetId}</> : '-'}
                                </div>
                                <div style={{ minHeight: 35, flex: 1, padding: 5, display: 'flex', alignItems: 'center', borderRight: '1px solid var(--border-color)' }}>{item.ratio ? item.ratio.toFixed(2) : item.ratio} %</div>
                                <div style={{ minHeight: 35, flex: 1, padding: 5, display: 'flex', alignItems: 'center', borderRight: '1px solid var(--border-color)' }}>{item.amount ? item.amount.toFixed(3) : item.amount}</div>

                            </div>
                        )
                    })
                }
                {poData.costAllocationDone  && poData && (poData.status === 'DRAFT')?
                    (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            width: '100%',
                            background: '#fff',
                            marginTop: 20,
                            gap: 12,
                        }}>
                            <div onClick={() => {
                                onRemove(true)
                            }} style={{ background: "#ffdad4", color: '#ba1b1b', padding: 12, display: 'flex', justifyContent: 'center', borderRadius: 10 }}>
                                Remove
                            </div>
                            <div onClick={() => {
                                onUpdate()
                            }} style={{
                                padding: 12, display: 'flex', justifyContent: 'center', borderRadius: 10,
                                background: 'var(--primary-color)',
                                border: 'none',
                                cursor: 'pointer',
                                marginLeft: 8,
                                color: 'white',
                            }}>
                                Update
                            </div>
                        </div>
                    ) : poData && poData.status === 'DRAFT' ? (
                        <div style={{
                            background: '#fff',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            borderTop: '1px solid var(--border-color)', height: 55, padding: '10px'
                        }}>
                            <div onClick={() => {
                                onAdd()
                            }} className='btn btn-portlet' style={{ background: "#E4EFE7", }}>
                                Add Cost Allocation
                            </div>
                        </div>
                    ):null
                }
            </div>}


            {showChart && <Container width="40%" style={{
                container: {
                    margin: 0,
                    marginTop: 30
                }
            }}>
                <PieGraph
                    textColor="#fff"
                    colors={["#0d6efd", "#fd7e14", "#20c997", "#d63384"]}
                    title={`Cost Allocationasd`}
                    height={350}
                    data={pieData}
                    items={pieItems}
                />
            </Container>}
            {
                viewLogs ?
                    <Modal
                        hideButton={true}
                        show={true}
                        title="Logs"
                        close={() => {
                            setViewLogs(false)
                        }}
                        modalStyle={{
                            marginRight: '1.5%',

                        }}
                    >
                        {
                            logs.map(log)
                        }
                    </Modal> : null
            }


        </div>
    )
})

AllocationView.defaultProps = {
    type: 'purchase-order',
}

export { AllocationView }